import { customColors } from '@apollo/orbit';
import React, { CSSProperties } from 'react';
import { PrismAsyncLight as Prism } from 'react-syntax-highlighter';
import { dark, prism } from 'react-syntax-highlighter/dist/esm/styles/prism';

import { useThemeContext } from 'src/components/themeProvider/ThemeProvider';
import { assertUnreachable } from 'src/lib/assertUnreachable';

export const JavascriptCodeBlock = ({
  code,
  showLineNumbers,
  style,
}: {
  code: string;
  showLineNumbers?: boolean;
  style?: CSSProperties;
}) => {
  const { themeName } = useThemeContext();
  return (
    <Prism
      language="javascript"
      style={
        themeName === 'light'
          ? prism
          : themeName === 'dark'
            ? dark
            : assertUnreachable(themeName)
      }
      showLineNumbers={showLineNumbers}
      customStyle={{
        borderRadius: '0.25rem',
        border: 'none',
        boxShadow: 'none',
        backgroundColor: customColors.bg.primary,
        ...style,
      }}
    >
      {code}
    </Prism>
  );
};
